import { useCallback } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

export const positiveInteger = (value, fallback = 1) => /^\d+$/.test(String(value)) && Number(value) > 0 ? Number(value) : fallback;

// Preserve navigation state (including the return link) while updating filters.
export default function useListingQuery() {
  const [query, setQuery] = useSearchParams();
  const location = useLocation();
  const update = useCallback((patch, { resetPage = false, replace = false } = {}) => {
    setQuery(current => {
      const next = new URLSearchParams(current);
      Object.entries(patch).forEach(([key, value]) => {
        if (value === "" || value === undefined || value === null) next.delete(key);
        else next.set(key, String(value));
      });
      if (resetPage) next.delete("page");
      return next;
    }, { replace, state: location.state });
  }, [setQuery, location.state]);
  return { query, update };
}
